import { Edit, EditProps, SelectInput, TextInput, useRedirect } from 'react-admin';
import { useParams } from 'react-router-dom';
import { EmptyStringTextInput } from '@/components/inputs';
import { DefaultToolbar } from '@/components/toolbars';
import { GENDER_CHOICES, path } from '@/pages/Candidate/constants';
import { CHOICES_MANUAL, PROFILE_STATUS_CHOICES, SSN_CHOICES } from '@/pages/Candidate/actions/Edit/constants';
import { Row, SimpleFormStyled } from '@/pages/Candidate/actions/Edit/styled';
import { transformWorkerDetails } from '@/pages/Candidate/utils';
import { StateInput } from '@/pages/Candidate/view/inputs';
import { TurnReferencesEnum } from '@/types/turn-enums';
import { validateFirstName, validateLastName, validateMiddleName, validatePhoneNumber, validateZipCode } from '@/utils';
import { transformSubmitData } from './utils';

const CandidateEdit = (props: EditProps) => {
  const redirect = useRedirect();
  const { id: workerId } = useParams<{ id: string }>();

  const handleClose = () => redirect(`/${TurnReferencesEnum.Candidates}/${workerId}/show`);

  return (
    <Edit redirect="show" title={'Candidate'} transform={transformSubmitData} {...props}>
      <SimpleFormStyled defaultValues={transformWorkerDetails} toolbar={<DefaultToolbar onClose={handleClose} />}>
        <Row>
          <EmptyStringTextInput source={path('first_name')} validate={validateFirstName} />
          <EmptyStringTextInput source={path('last_name')} validate={validateLastName} />
          <EmptyStringTextInput source={path('middle_name')} validate={validateMiddleName} />
          <EmptyStringTextInput source={path('candidate_email')} />
        </Row>
        <Row>
          <TextInput label="SSN" source={path('ssn_new')} /> {/* NOTE: used so we don't expose ssn */}
          <SelectInput source={path('is_ssn_valid')} choices={SSN_CHOICES} optionText="label" optionValue="value" />
          <SelectInput source={path('is_ssn_deceased')} choices={SSN_CHOICES} optionText="label" optionValue="value" />
          <SelectInput source={path('gender')} choices={GENDER_CHOICES} />
        </Row>
        <Row>
          <EmptyStringTextInput source={path('candidate_provided_name')} label="Name Entered" />
          <EmptyStringTextInput source={path('public_provided_name')} label="Public Records Name" />
          <EmptyStringTextInput source={path('zipcode')} label="Zipcode" validate={validateZipCode} />
          <EmptyStringTextInput source={path('phone_number')} label="Phone Number" validate={validatePhoneNumber} />
        </Row>
        <Row>
          <EmptyStringTextInput source={path('candidate_provided_date_of_birth')} label="DOB Entered" />
          <EmptyStringTextInput source={path('public_provided_date_of_birth')} label="Public Records DOB" />
          <EmptyStringTextInput source={path('reference_id')} label="Reference ID" />
        </Row>
        <Row>
          <EmptyStringTextInput source={path('drivers_license_number')} />
          <StateInput label="Driver License State" source={path('drivers_license_state')} include_prefix={false} />
        </Row>
        <Row>
          <EmptyStringTextInput source={path('mvr_driver_full_name')} label="MVR Full Name" />
          <EmptyStringTextInput source={path('mvr_driver_license_dob')} label="MVR DOB" />
          <SelectInput
            source={path('is_mvr_report_updated')}
            choices={CHOICES_MANUAL}
            optionText="label"
            optionValue="value"
          />
          <SelectInput source={path('profile_status')} choices={PROFILE_STATUS_CHOICES} />
        </Row>
        <Row>
          <SelectInput
            source={path('is_manual_background_check')}
            choices={CHOICES_MANUAL}
            optionText="label"
            optionValue="value"
          />
        </Row>
      </SimpleFormStyled>
    </Edit>
  );
};

export default CandidateEdit;
